export default "__VITE_ASSET__1e008a86__"